import React from 'react';
import { Alert, AlertTitle, Snackbar } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { closeAlert } from '../../store/slices/alertSlice';

export default function MessageAlert() {
  const alert = useSelector((state) => state.alert);
  const dispatch = useDispatch();

  return (
    <Snackbar
      open={alert.open}
      autoHideDuration={4000}
      onClose={() => dispatch(closeAlert())}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity={alert.severity}
        onClose={() => dispatch(closeAlert())}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {alert.title && <AlertTitle>{alert.title}</AlertTitle>}
        {alert.message}
      </Alert>
    </Snackbar>
  );
}
